var resolveConfig = require('tailwindcss/lib/util/resolveConfig');
var getAllConfigs = require('tailwindcss/lib/util/getAllConfigs');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var resolveConfig__default = /*#__PURE__*/_interopDefaultLegacy(resolveConfig);
var getAllConfigs__default = /*#__PURE__*/_interopDefaultLegacy(getAllConfigs);

function processTheme(theme, { exclude = [], replacer }) {
    let replacedTheme = theme;
    for (const [key, value] of Object.entries(replacedTheme)) {
        if (exclude.includes(key))
            continue;
        let val = value;
        switch (typeof value) {
            case "object":
                val = processTheme(value, { exclude, replacer });
                break;
            case "string":
                val = replacer(value);
                break;
        }
        replacedTheme[key] = val;
    }
    return replacedTheme;
}

const remUnitRegex = /"[^"]+"|'[^']+'|url\([^)]+\)|(\d*\.?\d+)rem/g;

function toEM(value) {
    return value.replace(remUnitRegex, (match, remDigit) => {
        const amount = Number(remDigit);
        if (Number.isNaN(amount)) {
            return match;
        }
        return `${amount}em`;
    });
}
function toPX(value) {
    return value.replace(remUnitRegex, (match, remDigit) => {
        const amount = Number(remDigit);
        if (Number.isNaN(amount)) {
            return match;
        }
        return `${amount * 16}px`;
    });
}

const defaultOpts = {
    exclude: ["fontFamily"],
};
const replaceTailwindUnit = (opts) => (userConfig) => {
    if (!userConfig) {
        throw new Error("tailwindcss config is required");
    }
    const mergedOpts = { ...defaultOpts, ...opts };
    if (!mergedOpts.replacer || typeof mergedOpts.replacer !== "function") {
        throw new Error("replacer function is required");
    }
    const { theme, ...config } = resolveConfig__default['default']([...getAllConfigs__default['default'](userConfig)]);
    return {
        ...config,
        theme: processTheme(theme, mergedOpts),
    };
};

exports.processTheme = processTheme;
exports.remUnitRegex = remUnitRegex;
exports.replaceTailwindUnit = replaceTailwindUnit;
exports.toEM = toEM;
exports.toPX = toPX;
